import { useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom'
import URL from '../constants/url'

function Header() {
  const toggleMobileMenu = () => {
    const allMenuMobile = document.querySelector('.all_menu.Mobile');
    const isClosed = allMenuMobile.classList.contains('closed');
    allMenuMobile.classList.toggle('closed', !isClosed); // 'closed' 클래스를 토글
    const btnAllMenuM = document.querySelector('.btnAllMenuM');
    btnAllMenuM.title = isClosed ? '전체메뉴 열림' : '전체메뉴 닫힘';
  };

  const closeMenuOutsideClick = (e) => {
    if (!e.target.closest('.menu') && !e.target.closest('.btnAllMenuM')) {
      document.querySelector('.all_menu.Mobile').classList.add('closed');
      document.querySelector('.btnAllMenuM').title = '전체메뉴 닫힘';
    }
  };

  useEffect(() => {
    // 모든 클릭 이벤트에서 메뉴 외부 클릭을 확인
    document.addEventListener('mousedown', closeMenuOutsideClick);
    // document.addEventListener('touchstart', closeMenuOutsideClick);

    return () => {
      document.removeEventListener('mousedown', closeMenuOutsideClick);
      // document.removeEventListener('touchstart', closeMenuOutsideClick);
    };
  }, []);

  return (
    <div className='header'>
      <div className='inner'>
        <div className='inner_layout'>
          <div className='inner_logo_con'>
            <div className='inner_logo'>
              <Link to={URL.MAIN} className='m'><img src='/images/eksys_logo.png' alt='eksys이케이시스' /></Link>
            </div>
          </div>
          <div className='gnb_con'>
            <div className='global_navigation_bar'>
              <NavLink to={URL.ABOUT} ><div className='gnb_item'>회사소개</div></NavLink>
              <NavLink to={URL.PRODUCTS} ><div className='gnb_item'>제품소개</div></NavLink>
              <NavLink to={URL.CONTACT} ><div className='gnb_item'>오시는 길</div></NavLink>
            </div>
          </div>
          <div className="right_a">
            <button type="button" onClick={toggleMobileMenu} className="btn mobile btnAllMenuM" title="전체메뉴 닫힘">전체메뉴</button>
          </div>
        </div>
      </div>


      <div className="all_menu Mobile closed">
        <div className="menu">
          <div className="user_info_m">
            <button onClick={toggleMobileMenu} className="btn noscript close" type="button">전체메뉴 닫기</button>
          </div>
          <Link to={URL.ABOUT} onClick={toggleMobileMenu} className="mo_side_h3">
            <h3>회사소개</h3>
          </Link>
          <Link to={URL.PRODUCTS} onClick={toggleMobileMenu} className="mo_side_h3">
            <h3>제품소개</h3>
          </Link>
          <Link to={URL.CONTACT} onClick={toggleMobileMenu} className="mo_side_h3">
            {/* <h3>개발문의</h3> */}
            <h3>오시는 길</h3>
          </Link>
        </div>
      </div>

    </div>
  )
}

export default Header
